import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import {
  SaleTag,
  SaleTagsCreateRequest,
  SaleTagsQueryFilter,
  SaleTagsUpdateRequest,
} from './SaleTags.types';

const CONTROLLER_URL = `${API_BASE_URL}/sale-tags`;

export async function listSaleTags(params?: SaleTagsQueryFilter) {
  const result = (await api.get(`${CONTROLLER_URL}`, {
    ...params,
  })) as unknown;

  return result as PageResult<SaleTag>;
}

export async function createSaleTag(obj: SaleTagsCreateRequest) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}

export async function detailsSaleTag(saleTagId?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${saleTagId}`,
    {},
  )) as unknown;

  return result as PageResult<SaleTag>;
}

export async function updateSaleTag(params: SaleTagsUpdateRequest) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${params.id}`,
    params,
    null,
  )) as unknown;

  return result;
}

export async function deleteSaleTag(saleTagId?: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${saleTagId}`,
    {},
    null,
  )) as unknown;

  return result;
}
